import { cilArrowLeft, cilBackspace } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { CButton } from '@coreui/react'
import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

export default function TenderTabs(props) {
    const navigate = useNavigate()

    return (
        <>
            <div className="container mt-1">
                <ul className="nav nav-pills ">

                    <li className="nav-item">
                        <Link
                            className={props.tab_id === 1 ? 'nav-link active' : 'nav-link'}
                            to={`/`}
                        >
                            Open Tenders
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link
                            className={props.tab_id === 2 ? 'nav-link active' : 'nav-link'}
                            to={`/close_tenders`}
                        >
                            Close Tenders
                        </Link>
                    </li>
                </ul>
            </div>
        </>
    )
}
